import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaIcon from './VaIcon.vue'

export const VaIcon = withConfigTransport(_VaIcon)
